let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("g3sTA")).then(() => parcelRequire('4ftaS'));